import { Typography, TypographyProps } from '@mui/material'
import React, { ElementType } from 'react'

type Variant = TypographyProps['variant']

interface TextProps {
  variant?: Variant
  component?: string
  children?: React.ReactNode
  className?: string
  sx?: object
}

const Text: React.FC<TextProps> = ({
  children = null,
  component = 'p',
  variant = 'body1',
  className = undefined,
  sx = undefined
}) => (
  <Typography
    component={component as ElementType}
    variant={variant} // Directly use the variant prop without variantMapping
    className={className}
    sx={sx}
  >
    {children}
  </Typography>
)

export default Text
